module.exports = __webpack_public_path__ + "img/DSM_IntoxicatingSpaces_Logo_2x.7c331f15.png";